import { AreaChartWebElementBase } from './AreaChartWebElementBase';

/**
 * The component WebElement for [oj-c-area-chart](../../jsdocs/oj-c.AreaChart.html).
 * Do not instantiate this class directly, instead, use
 * [findAreaChart](../functions/findAreaChart.html).
 */
export class AreaChartWebElement extends AreaChartWebElementBase {
  // Put overrides here
}
